/**
 * The ONE score-band table — JS mirror of backend/audit/scoring.py.
 *
 * Every gauge, legend, badge and per-dimension chip in the web report reads
 * from here, so a score can never render one colour and be labelled another
 * band. There are no letter grades.
 *
 * DO NOT edit these four rows without editing SCORE_BANDS in
 * backend/audit/scoring.py to match. backend/tests/test_score_band_parity.py
 * parses this file and fails if the two tables disagree on any integer 0-100.
 *
 * Approved palette, measured on the product canvas #faf9f5 (all AA at 14px):
 *   Excellent  #2E7D5B  4.75:1
 *   Good       #8C6A1A  4.76:1
 *   Needs Work #A0563C  5.12:1
 *   Critical   #A6123A  7.20:1
 *
 * DO NOT DEEPEN CRITICAL FOR THE CONTRAST NUMBER. #8F2A26 was tried: it reads
 * better alone (7.89:1) but moves toward the Needs Work clay, collapsing their
 * separation from dE00 17.9 to 12.6. See the full reasoning in scoring.py.
 */

export const SCORE_BANDS = [
  { lo: 80, hi: 100, label: 'Excellent', color: '#2E7D5B' },
  { lo: 60, hi: 79, label: 'Good', color: '#8C6A1A' },
  { lo: 40, hi: 59, label: 'Needs Work', color: '#A0563C' },
  { lo: 0, hi: 39, label: 'Critical', color: '#A6123A' },
];

/**
 * The band for an UNROUNDED score. Out-of-range values clamp to [0,100].
 * Mirrors scoring.score_band: compares against `lo` on the high-first table.
 */
export const scoreBand = (value) => {
  const v = Math.max(0, Math.min(100, Number(value) || 0));
  return SCORE_BANDS.find((b) => v >= b.lo) || SCORE_BANDS[SCORE_BANDS.length - 1];
};

export const bandColor = (value) => scoreBand(value).color;
export const bandLabel = (value) => scoreBand(value).label;

/** Translucent wash of the band colour, for gauge/card backgrounds. */
export const bandTint = (value, alpha = 0.1) => {
  const hex = bandColor(value).replace('#', '');
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  return `rgba(${r},${g},${b},${alpha})`;
};
